import type {AppRouteConfig} from './route.types';
import CityStoresPage from '../pages/myAccount/my-credits/step0-startLoanCredit/CityStoresPage';
import DirectLoanDocsPage from '../pages/lendtech/receiveCredit/step3-completeDocs/direct-loan/DirectLoanDocsPage';
import SelectLoanPage from '../pages/lendtech/receiveCredit/step2-selectLoan/SelectLoanPage';
import ReceiveLoanPage from '../pages/lendtech/receiveLoan/step4-receiveLoan/ReceiveLoanPage';
import ValidationDetailPage from '../pages/lendtech/receiveCredit/step1-validation/status3/validationDetail/ValidationDetailPage';
import LoanStatusWrapper from '../pages/lendtech/LoanStatusWrapper';
import ValidationPage from '../pages/lendtech/receiveCredit/step1-validation/ValidationPage';

export const receiveLoanRoutes: AppRouteConfig[] = [
  {path: 'city-contract-stores/:stateId', element: CityStoresPage},
  {
    path: 'receive-loan',
    element: LoanStatusWrapper,
    children: [
      {path: 'step-1', element: ValidationPage},
      {path: 'step-2', element: SelectLoanPage},
      {path: 'step-3', element: DirectLoanDocsPage},
      {path: 'step-4', element: ReceiveLoanPage},
    ],
  },
  {
    path: 'receive-loan/step-1/validation-detail/:loanGuid',
    element: ValidationDetailPage,
  },
];
